module.exports = __webpack_public_path__ + "8a174a4150c524219503eb923b4a9bee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-19.png
// module id = 1428
// module chunks = 0